import { OENLockedState } from "../enums/oe-locked-state.enum";
import { ICNInputControlState } from "../../interface/controls/models/bfx-interface-controls.enums";
import { OEPanelSpotModel } from "./oe-panel-spot.model";

export class OEPanelGammaModel extends OEPanelSpotModel {
  public delta: {
    label: string;
    labelKey: string;
    value: number;
    oldValue: number;
    externalState: ICNInputControlState;
    lockState: OENLockedState;
    precision: number;
    step: number;
    disabled: boolean;
    minValue: number;
    duplicateDelta: boolean;
  } = {
    label: "Delta",
    labelKey: "order_entry.panel.label.delta",
    value: 0.0,
    oldValue: 0.0,
    externalState: null,
    lockState: OENLockedState.UNLOCKED,
    precision: 1,
    step: 1,
    disabled: false,
    minValue: 0,
    duplicateDelta: false,
  };

  public rungsAbove: {
    label: string;
    labelKey: string;
    value: number;
    oldValue: number;
    externalState: ICNInputControlState;
    lockState: OENLockedState;
    disabled: boolean;
    maxRungs: number;
    max: number;
  } = {
    label: "Rungs Above",
    labelKey: "order_entry.panel.label.rungsAbove",
    value: 0,
    oldValue: 0,
    externalState: null,
    lockState: OENLockedState.UNLOCKED,
    disabled: false,
    maxRungs: 20,
    max: 20,
  };

  public rungsBelow: {
    label: string;
    labelKey: string;
    value: number;
    oldValue: number;
    externalState: ICNInputControlState;
    lockState: OENLockedState;
    disabled: boolean;
    max: number;
  } = {
    label: "Rungs Below",
    labelKey: "order_entry.panel.label.rungsBelow",
    value: 0,
    oldValue: 0,
    externalState: null,
    lockState: OENLockedState.UNLOCKED,
    disabled: false,
    max: 20,
  };
}
